import { useAuthContext } from '../../../../context/auth.context'

// Per-resource API key permissions are EducationXR staff's at first (spec
// 2026-10-20 §10, "visible to sys admins only"; core answers anyone else
// 403 api_key.grants_staff_only). A code constant, like LMS_STAFF_ONLY
// (view/lms-admin/staff-only.js): lifting it is this line, the server's
// rule and a redeploy.
export const API_KEY_GRANTS_STAFF_ONLY = true

// Whether this session sees the grants UI: a system administrator or root in
// their own session. Never an impersonated one (core refuses grants from
// one), and never through useRoleOrg's full-access shortcut, which is about
// the organization's own permissions.
export const keyGrantsVisible = state => {
  if (!state) return false
  if (state.jwtClaims && state.jwtClaims.impersonationEndsAt) return false
  return !API_KEY_GRANTS_STAFF_ONLY || !!(state.isSysAdmin || state.isSysRoot)
}

// Whether this session is EducationXR staff acting as themselves (a system
// administrator or root, never an impersonated session), whatever the
// switch above says: what core's own "staff" test is, for what is staff's
// by nature, not by a switch (rotating a key that holds a platform-only
// resource).
export const isKeyStaff = state => {
  if (!state) return false
  if (state.jwtClaims && state.jwtClaims.impersonationEndsAt) return false
  return !!(state.isSysAdmin || state.isSysRoot)
}

export const useKeyGrantsVisible = () => {
  const context = useAuthContext()
  return keyGrantsVisible(context && context.state)
}
